import { useEffect, useState } from "react";
import { getConsent } from "@/lib/consent";

/**
 * Injects Google Analytics 4 + Google Search Console tags at runtime.
 * - GA4 (analytics) only loads AFTER user grants analytics consent
 * - GSC (search console meta) can load regardless (it's a passive verification tag)
 * Env: REACT_APP_GA_ID, REACT_APP_GSC_VERIFICATION
 */
export default function Analytics() {
  const [consent, setConsent] = useState(getConsent());

  useEffect(() => {
    const handler = () => setConsent(getConsent());
    window.addEventListener("tas-consent-change", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("tas-consent-change", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  useEffect(() => {
    const GA_ID = (process.env.REACT_APP_GA_ID || "").trim();
    const allowAnalytics = !!consent?.analytics;

    if (GA_ID && allowAnalytics && !document.getElementById("ga4-loader")) {
      const s1 = document.createElement("script");
      s1.id = "ga4-loader";
      s1.async = true;
      s1.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
      document.head.appendChild(s1);

      const s2 = document.createElement("script");
      s2.id = "ga4-init";
      s2.text =
        `window.dataLayer = window.dataLayer || [];` +
        `function gtag(){dataLayer.push(arguments);}` +
        `window.gtag = gtag; gtag('js', new Date());` +
        `gtag('config', ${JSON.stringify(GA_ID)}, {anonymize_ip: true});`;
      document.head.appendChild(s2);
    }

    const GSC = (process.env.REACT_APP_GSC_VERIFICATION || "").trim();
    if (GSC && !document.querySelector('meta[name="google-site-verification"]')) {
      const meta = document.createElement("meta");
      meta.setAttribute("name", "google-site-verification");
      meta.setAttribute("content", GSC);
      document.head.appendChild(meta);
    }
  }, [consent]);

  return null;
}
